var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-row',[_c('b-col',[_c('h1',[_vm._v("Area Utente")]),_c('p',[_vm._v("Questa é l'area utente...")])]),_c('b-col',{attrs:{"cols":"4"}},[_c('bc-newsfeed',{attrs:{"tweets":"7"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }